const MAX_LOGS = 100;
const BATCH_MAX = 10;
const BATCH_INTERVAL = 4000; // 4s flush
const SESSION_ID = (() => {
  try { return sessionStorage.getItem('sessionId') || ( () => { const id = Math.random().toString(36).slice(2); sessionStorage.setItem('sessionId', id); return id; })(); } catch { return 'nosession'; }
})();
let batchTimer = null;
const STATE = { logs: [], lastPost: 0, queue: [], signatureCounts: {}, signatureWindow: 60_000 };
const STORAGE_KEY = 'appErrorLogsV1';
const REMOTE_ENDPOINT = import.meta.env.PROD
  ? 'https://wasser-pro-api.sherhan1988hp.workers.dev/api/logs'
  : (import.meta?.env?.VITE_API_BASE_URL || '') + '/api/logs';

function persist() {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(STATE.logs)); } catch {}
}

export function loadPersistedErrors() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) STATE.logs = JSON.parse(raw).slice(-MAX_LOGS);
  } catch {}
}

function enqueueForRemote(entry) {
  STATE.queue.push(entry);
  if (STATE.queue.length >= BATCH_MAX) {
    flushQueue();
    return;
  }
  if (!batchTimer) {
    batchTimer = setTimeout(() => { flushQueue(); }, BATCH_INTERVAL);
  }
}

async function flushQueue() {
  if (batchTimer) { clearTimeout(batchTimer); batchTimer = null; }
  if (!STATE.queue.length) return;
  const payload = { entries: STATE.queue.splice(0, STATE.queue.length), sessionId: SESSION_ID };
  try {
    fetch(REMOTE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(()=>{});
  } catch {}
}

function shouldSample(signature) {
  const now = Date.now();
  // Reset window periodically
  if (!STATE.windowStart || now - STATE.windowStart > STATE.signatureWindow) {
    STATE.windowStart = now;
    STATE.signatureCounts = {};
  }
  const count = (STATE.signatureCounts[signature] || 0) + 1;
  STATE.signatureCounts[signature] = count;
  // Allow first 5 occurrences, then sample 1 of every 10
  if (count <= 5) return true;
  return count % 10 === 0; // keep 10th, 20th etc.
}

export function logError(error, extra = {}, level = 'error') {
  const entry = {
    time: new Date().toISOString(),
    message: error?.message || String(error),
    name: error?.name || 'Error',
    stack: error?.stack || null,
    level,
    sessionId: SESSION_ID,
    extra
  };
  const signature = entry.name + '|' + entry.message + '|' + (entry.stack ? entry.stack.split('\n')[0] : '');
  if (shouldSample(signature)) {
    STATE.logs.push(entry);
    if (STATE.logs.length > MAX_LOGS) STATE.logs.shift();
    persist();
    enqueueForRemote(entry);
  } else {
    // Update last occurrence timestamp silently
    entry.sampled = true;
  }
  return entry;
}

export function getErrorLogs() { return [...STATE.logs].reverse(); }
export function clearErrorLogs() { STATE.logs = []; persist(); }
export function flushErrorLogs() { flushQueue(); }

// Dev helper to quickly attach to window.
if (typeof window !== 'undefined') {
  window.__APP_ERRORS__ = { getErrorLogs, clearErrorLogs };
}
